<template>
  <form
    class="grid grid-cols-2 gap-4 overflow-hidden rounded-lg p-1 sm:grid-cols-4"
    @submit="onSubmit"
  >
    <input class="hidden" type="password" />
    <FormInputPassword
      name="pin"
      type="pin"
      label="Supervisor Pin"
      :max-length="4"
      class=""
    />

    <div
      class="col-start-2 flex items-end justify-end sm:col-start-4"
    >
      <FormSubmitButton :disabled="!meta.valid">
        Save
      </FormSubmitButton>
    </div>
    <template v-if="isSubmitting">
      <div class="absolute inset-0 bg-background-fg/8">
      </div>
    </template>
  </form>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const supervisorPinFormSchema = z.object({
  pin: z
    .string()
    .length(4, "Supervisor PIN must be 4 digits long")
    .regex(
      /\d{4}/,
      "Supervisor Pin must only contain numbers"
    ),
})

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(supervisorPinFormSchema),
  initialValues: { pin: "" },
})

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (params) => {
  isSubmitting.value = true
  try {
    await updateSupervisorPin(params)
    toast.success("Supervisor PIN changed")
  } catch (error) {
    toast.error("Failed to change supervisor pin")
    logError(error)
  } finally {
    isSubmitting.value = false
  }
})
</script>
